import { render, staticRenderFns } from "./isole-e-olena.vue?vue&type=template&id=2961014e&scoped=true"
import script from "./isole-e-olena.vue?vue&type=script&lang=js"
export * from "./isole-e-olena.vue?vue&type=script&lang=js"
import style0 from "./isole-e-olena.vue?vue&type=style&index=0&id=2961014e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2961014e",
  null
  
)

export default component.exports